module.exports = __webpack_public_path__ + "static/media/like.19183385.svg";